export default {
  menus: {
    '/': 'home',
    home: 'home',
    users: 'users list',
    roles: 'roles list',
    rights: 'permission list',
    goods: 'product list',
    params: 'sorting list',
    categories: 'goods category',
    orders: 'order list',
    reports: 'data report'
  },
  login: {
    title: 'user login',
    btnTitle: 'login'
  },
  dialog: {
    deleteTitle: 'Are you sure you want to delete the user '
  },
  userTable: {
    type: 'type',
    username: 'username',
    realName: 'realName',
    name: 'name',
    department: 'department',
    position: 'position',
    Teacher: 'Teacher',
    student: 'student',
    other: 'other',

    phone: 'phone',
    search: 'search',
    adduser: 'add user',
    placeholder: 'Please enter a user name to search for',
    placeholder1: 'Please enter a user nickname for your search',
    man: 'man',
    woman: 'woman',
    gender: 'gender',
    password: 'password',
    nickName: 'nickName',
    email: 'email',
    departmentName: 'departmentName',
    roleName: 'roleName',
    userList: 'userList',
    vehicleList: 'vehicleList',
    routeList: 'routeList',
    system: 'system manage'
  },
  user: {
    add: 'addUser',
    edit: 'editUser'
  },
  table: {
    Controls: 'Controls',
    createTime: 'createTime'
  },
  role: {
    roleId: 'roleId',
    roleCode: 'roleCode',
    roleName: 'roleName',
    remark: 'remark',
    search: 'Please enter a role name',
    edit: 'edit',
    add: 'add'
  },
  department: {
    placeholder: 'Please enter a department name',
    departmentName: 'departmentName',
    parentName: 'parentName',
    phone: 'phone',
    address: 'address',
    orderNum: 'orderNum',
    add: 'add',
    edit: 'edit'
  },
  menu: {
    menuName: 'menuName',
    menuType: 'menuType',
    menuIcon: 'menuIcon',
    routeName: 'routeName',
    routeAddress: 'routeAddress',
    moduleAddress: 'moduleAddress',
    catalog: 'catalog',
    menu: 'menu',
    button: 'button',
    routPath: 'routPath',
    permission: 'permission',
    pagePath: 'pagePath',
    buttonName: 'buttonName',
    qwning: 'qwningMenu',
    orderNum: 'orderNum',
    name: 'name',
    icon: 'icon',
    add: 'add',
    edit: 'edit'
  },
  site: {
    ID: 'ID',
    locationNumber: 'locationNumber',
    buildingName: 'buildingName',
    classroomName: 'classroomName',
    numberOfSeats: 'numberOfSeats',
    row: 'row',
    column: 'column',
    customCol: 'customCol',
    addCol: 'addCol',
    createSeats: 'createSeats',
    editSeats: 'editSeats',
    setSeats: 'setSeats',
    type: 'type',
    status: 'status',
    mode: 'mode',
    number: 'number'
  },
  time: {
    timeCode: 'timeCode',
    startTime: 'startTime',
    endTime: 'endTime',
    timeName: 'timeName'
  },
  // 教室编号
  seatCode: {
    code: 'code',
    add: 'add',
    edit: 'edit'
  },
  classType: {
    type: 'type',
    add: 'add',
    edit: 'edit'
  },
  building: {
    buildingName: 'buildingName',
    add: 'add',
    edit: 'edit'
  },
  course: {
    courseCode: 'courseCode',
    courseName: 'courseName',
    img: 'img',
    type: 'type'
  },
  coursesType: {
    type: 'coursesType',
    add: 'add',
    edit: 'edit'
  },
  // 车辆管理
  vehicle: {
    add: 'addVehicle',
    edit: 'editVehicle',
    vehicleCode: 'vehicleCode',
    licensePlate: 'licensePlate',
    vehicleName: 'vehicleName',
    model: 'model',
    color: 'color',
    numPeople: 'numPeople',
    vehicleStatus: 'vehicleStatus',
    dynamic: 'dynamic',
    inertia: 'inertia',
    maintenance: 'maintenance'
  },
  // 线路
  route: {
    add: 'addRoute',
    edit: 'editRoute',
    routeCode: 'routeCode',
    routeName: 'routeName',
    startStation: 'startStation',
    endStation: 'endStation',
    totalDuration: 'totalDuration',
    active: 'active',
    operation: 'operation',
    ceaseOperation: 'ceaseOperation'
  },
  trip: {
    code: 'code',
    username: 'username',
    name: 'vehicleName',
    routeName: 'routeName',
    startStation: 'startStation',
    destination: 'destination',
    reservationDate: 'reservationDate',
    seatsNeeded: 'seatsNeeded',
    status: 'status',
    beConfirmed: 'beConfirmed',
    confirmed: 'confirmed',
    canceled: 'canceled',
    reservation: 'Reservation selection list',
    vehicleBook: 'book a vehicle selection list',
    lineBook: 'Reservation line selection list'
  },
  // 公告
  affiche: {
    afficheCode: 'afficheCode',
    title: 'title',
    content: 'content',
    startTime: 'startTime',
    endTime: 'endTime',
    isActive: 'isActive',
    delist: 'delist',
    onDisplay: 'onDisplay',
    username: 'username',
    add: 'add',
    edit: 'edit'
  },
  // 课程管理
  curriculum: {
    code: 'code',
    username: 'username',
    siteName: 'siteName',
    coursesDay: 'coursesDay',
    coursesName: 'coursesName',
    timesName: 'timesName',
    category: 'category',
    giveLessons: 'giveLessons',
    exam: 'exam',
    report: 'report',
    thesis: 'thesis',
    timeFrame: 'timeFrame',
    add: 'add',
    edit: 'edit'
  },
  // 预约管理
  subscribe: {
    appointments: 'Number of appointments today',
    sign: 'Number of sign-ups today',
    departures: 'Number of departures today',
    week: 'Number of sign-ups this week',
    username: 'username',
    buildingName: 'buildingName',
    siteName: 'siteName',
    seatNumber: 'seatNumber',
    bookingDate: 'bookingDate',
    timeName: 'timeName',
    startTime: 'startTime',
    endTime: 'endTime',
    status: 'status',
    notSignedIn: 'not signed in',
    signedIn: 'signed in',
    signedOut: 'signed out',
    selecDate: 'selecDate',
    selecSite: 'selecSite'
  },
  rCategories: {
    code: 'code',
    categoryName: 'CategoryName',
    categoryType: 'CategoryType',
    add: 'add',
    edit: 'edit'
  },
  pushSettings: {
    userName: 'userName',
    categoryName: 'CategoryName',
    isEnabled: 'isEnabled',
    settings: 'pushSettings'
  },
  pushMessage: {
    code: 'code',
    categoryName: 'CategoryName',
    title: 'title',
    description: 'description',
    publishTime: 'publishTime',
    contents: 'contents',
    add: 'Add Message',
    edit: 'Edit Message'
  },
  personnel: {
    name: 'name',
    code: 'code'
  },
  message: {
    updeteSuccess: 'update successfully',
    addSuccess: 'add successfully',
    deleteSuccess: 'delete successfully',
    updeteFail: 'updete fail',
    addFail: 'add fail',
    deleteFail: 'delete fail',
    deleteMsg: 'Are you sure you want to delete it?',
    systemPrompt: 'system prompt',
    deleteMsg1: '确定对选中用户进行角色分配吗？这将导致覆盖掉原先用户拥有的角色！',
    setASeat: 'Are you sure you want to set the selected seat to unavailable status code？',
    unbanSeat: 'setASeat?'
  },
  driver: {
    doneBtnText: 'done',
    closeBtnText: 'close',
    nextBtnText: 'next',
    prevBtnText: 'prev',
    guideBtn: 'guidebtn',
    hamburgerBtn: 'hamburgerBtn',
    fullScreen: 'fullScreen'
  },
  personal: {
    personal: 'Personal Center',
    password: 'Change password',
    quit: 'quit'

  },
  buttons: {
    add: 'add',
    edit: 'edit',
    delete: 'delete',
    search: 'search',
    reset: 'reset',
    assignment: 'unified role assignment',
    allocation: 'roles allocation',
    cancel: 'cancel',
    confirm: 'confirm',
    authority: 'Assign authority',
    generating: 'Generating',
    view: 'view',
    viewSeate: 'setting seat',
    distribution: 'distribution',
    pushSetting: 'pushSetting',
    viewPush: 'viewPush',
    synchronizing: 'Synchronizing user data',
    import: 'Import User',
    campus: 'CampusAssistant',
    relevancy: 'relevancy'
  },
  logingzh: {
    loginName: 'Login Name',
    operatingSystem: 'Operating System',
    client: 'Client',
    browser: 'Browser',
    loginTime: 'Login Time'
  },
  requestlog: {
    IPAddress: 'IPAddress',
    Geolocation: 'Geolocation',
    Operator: 'Operator',
    OperationMethod: 'OperationMethod',
    OperationStatus: 'OperationStatus',
    OperationTime: 'OperationTime',
    OperationDuration: 'OperationDuration',
    LogDetails: 'LogDetails',
    RequestIP: 'RequestIP',
    RequestURL: 'RequestURL',
    ErrorMessage: 'ErrorMessage',
    RequiredParameter: 'RequiredParameter',
    ResponseParameter: 'ResponseParameter'
  },
  home: {
    total: 'Total student population',
    appointments: 'Number of today appointments',
    vehicles: 'Number of vehicles today',
    sign: 'Number of sign-ups today'
  },
  stop: {
    name: 'Stop name'
  }
}
